module.exports = __webpack_public_path__ + "static/media/and_scr_onboarding_03_c.9404d904.png";